<script>
    export default {
        name: "AppSnack",
        data() {
            return {
                snackOpen: false,
                snackText: null,
                snackColor: null,
                snackDelete: false,
                snackConfirm: true,
            }
        },
        methods: {
            closeSnack() {
                this.snackOpen = false;
            },
            openSnack() {
                this.snackOpen = true;
            },
            resetSnack() {
                this.snackOpen = false;
                this.snackText = null;
                this.snackColor = null;
                this.snackDelete = false;
                this.snackConfirm = false;
            },
            setConfirmSnackState() {
                this.snackConfirm = true;
            },
            setDeleteSnack() {
                this.snackColor = 'main--black';
            },
            setDeleteSnackState() {
                this.snackDelete = true;
            },
            setInfoSnack() {
                this.snackColor = 'main--black';
            },
            setSnackText(text) {
                this.snackText = text;
            },
            setSuccessSnack() {
                this.snackColor = 'main--black';
            },
        }
    }
</script>

<style scoped>

</style>
